export const getToken = () => {
  return localStorage.getItem("authToken");
};
